import { HttpClient } from 'api/http-client';
import { ConversationMember } from 'api/project-conversations';
import { ConversationContext } from 'data/conversation';
import {
  Comment,
  ContextType,
  ReactionJSONProps,
  Reaction,
  UserMessage,
} from './types';

type UserMessagePartial = Partial<UserMessage>;

const NAMESPACE = '/projects';

class ConversationHttpClient extends HttpClient {
  public async getComments(
    projectId: number,
    context: ConversationContext,
  ): Promise<{
    comments: Comment[];
    members?: ConversationMember[];
  }> {
    return this.get<Comment, { comments: Comment[] }>(
      `${NAMESPACE}/${projectId}/${ContextType[context.type]}/${
        context.id
      }/conversations`,
    );
  }

  public updateComment(
    projectId: number,
    context: ConversationContext,
    commentId: number,
    comment: UserMessagePartial,
  ): Promise<null> {
    return this.put<UserMessage, { comment: UserMessagePartial }, null>(
      `${NAMESPACE}/${projectId}/${ContextType[context.type]}/${
        context.id
      }/comments/${commentId}`,
      { comment },
    );
  }

  public async createComment(
    projectId: number,
    context: ConversationContext,
    comment: UserMessagePartial,
  ): Promise<UserMessage> {
    return (
      await this.post<
        UserMessage,
        { comment: UserMessagePartial },
        { comment: UserMessage }
      >(
        `${NAMESPACE}/${projectId}/${ContextType[context.type]}/${
          context.id
        }/comments`,
        { comment },
      )
    ).comment;
  }

  public async deleteComment(
    projectId: number,
    context: ConversationContext,
    commentId: number,
  ): Promise<null> {
    return this.delete<UserMessage, null>(
      `${NAMESPACE}/${projectId}/${ContextType[context.type]}/${
        context.id
      }/comments/${commentId}`,
    );
  }

  public addReaction(
    projectId: number,
    context: ConversationContext,
    commentId: number,
    reactionType: Reaction,
  ): Promise<ReactionJSONProps> {
    return this.post<ReactionJSONProps, ReactionJSONProps, ReactionJSONProps>(
      `/projects/${projectId}/${ContextType[context.type]}/${
        context.id
      }/comments/${commentId}/reactions`,
      {
        reactionType,
      },
    );
  }
}

export { ConversationHttpClient };

export const ConversationAPI = new ConversationHttpClient();

export * from './types';
